module.exports = `${require.publicPath}about-img03.4ae78136.png`;